import benefitModule1 from "../Benefit/benefitDefaultModuleProp";
import benefitModule2 from "../Benefit/benefitDefaultModuleProp";
import benefitModule3 from "../Benefit/benefitDefaultModuleProp";
import benefitModule4 from "../Benefit/benefitDefaultModuleProp";

const benefitsModule = {
  // other module props
  id: "9625e60e-5be2-39c9-a310-dd888e341674",
  config: {
    general: {
      paddings: {
        top: true,
        bottom: true,
      },
      media: {
        url: "https://tc-media.job-shop.com/content-modules/cover/header/cover-header.jpg",
        // url: 'https://css-tricks-post-videos.s3.us-east-1.amazonaws.com/708209935.mp4',
        mediaType: "image",
      },
      moduleBackgroundColor: {
        label: "Orange",
        value: "#ff4d01",
      },
      benefitBackgroundColor: {
        label: "white",
        value: "white",
      },
      template: {
        label: "Cube",
        component: "BenefitCube",
      },
      showIcon: true,
      showContent: true,
      showMedia: false,
      showHeader: true,

      corners: {
        label: "Round",
        value: "round",
      },
    },
  },
  modules: [benefitModule1, benefitModule2, benefitModule3, benefitModule4],
};

export default benefitsModule;
